//require('./debug-info-modal.component.scss');

export class DebugInfoModal {
  constructor($scope, $modalInstance) {
    $scope.ok = () => {
      $modalInstance.close();
    };
    $scope.cancel = () => {
      $modalInstance.close();
    };

    $scope.options = {
      log         : true,
      agent_config: true,
      agent_rule  : true,
    };

    $scope.getLink = () => `/analytics/debug?${
      Object.keys($scope.options)
        .filter(key => $scope.options[key]).join('&')
      }`;
  }
}



// WEBPACK FOOTER //
// ./src/admin/debug-info-modal.component.js